import React, { useContext } from "react"
import {Navigate} from  "react-router-dom"
import { AuthContext } from "../Context/UseAuthContext"


const ProtectedRoute = ({children}) =>{
const {user} = useContext(AuthContext)
console.log("Check user in Private: ", user);

  if (!user) {
    return <Navigate to="/logIn" />;
  }
  return children;
};

export default ProtectedRoute;

